<template>
  <div v-bind:class="overrideClass" v-if="!hideIfNoRecords || itemsData.length !== 0">
    <!-- Component error message -->
    <div v-if="componentErrorMessage" class="error">
      <p>{{ componentErrorMessage }}</p>
    </div>

    <!-- Search bar -->
    <div v-if="search && !contentOnly" class="form-row">
      <input type="text" :placeholder="$t('generic.overview.search.placeholder')" v-model="itemsSearchValue" v-on:keyup.enter="getSearch()"
             v-on:keyup="searchOnChange()"/>
        <router-link :to="constructNewOverviewUrl()">
          <button type="submit" class="search" v-on:click="getSearch()"><i class="ion-search"></i></button>
        </router-link>
    </div>

    <div v-if="itemsShowLoading">
      <i class="ion-loop loading-animation"></i>
    </div>
    <div v-else>
      <!-- Items discoverd bar -->
      <div v-if="!contentOnly" class="row pagination-list">
        <span v-if="!itemsError">{{ $t('generic.overview.pagination.pagesize.before') }}</span>
        <select v-if="!itemsError" v-model="paginationPageSize" @change="handlePaginationPageSize">
          <option v-for="(option, index) in paginationPageSizeOptions" :key="index" :value="option">{{ option }}</option>
        </select>
        <span v-if="!itemsError">{{ $t('generic.overview.pagination.pagesize.after') }}</span>

        <!-- Add item bar -->
        <div v-if="!contentOnly" class="form-row column__50 text-right">
          <a v-if="actions.create.action && showButtons.create" class="link" icon="plus" :loading="false" :title="actions.create.label"
             :alt="actions.create.label" @click="actions.create.action">
            <i class="ion-plus"></i> {{ actions.create.label }}
          </a>
        </div>
      </div>

      <!-- Table -->
      <div v-if="itemsError" class="error--text">{{ overrideError ? $t(overrideError) : itemsError }}</div>
      <div v-else class="table-scroll">
        <table class="border" v-bind:class="{ zebra: rows.zebra }">
          <thead>
          <tr>
            <th v-for="(column, index) in columns" :key="index" v-bind:style="{ textAlign: column.headerAlign }">
              <a @click="sort(column.name)" style="text-decoration: none;">
                {{ column.label }}
                <i v-if="isSortField(column.name)" :class="(getSortDirection() === 'desc' ? 'el-icon-arrow-down' : 'el-icon-arrow-up')"></i>
              </a>
            </th>
            <th class="tools">
              <a class="tools--link">
                <i v-if="filterHasToBeDisplayed()" @click="startFilterScreen()"
                   :class="(isFilterEnabled() ? 'ion-funnel' : 'ion-android-funnel')"></i>
              </a>
            </th>
          </tr>
          <td v-if="!contentOnly"></td>
          </thead>
          <tbody>
          <tr v-for="(item, index) in itemsData" :key="index" :class="{ canceled: item.canceled }">
            <td v-for="(column, index) in columns" :key="index" @click="((column.action && column.name !== 'currentValue') ? column.action({item}) : null)"
                v-bind:style="{ width: column.width, textAlign: column.align }" :class="(column.action ? 'click-cell' : null)">
              {{ column.processor ? filter(column.processor(item[column.name]), column.filter, item) : filter(item[column.name], column.filter, item)
              }}
            </td>
            <td class="tools">
              <a v-if="!containsUserRole('dealerview')" class="tools--link" v-for="ia in itemActions" :key="ia" @click="ia.perform(item, index)">
                <i :class="ia.icon"></i>
              </a>

              <a v-if="!actions.unlock.disable && actions.unlock.column.identifier && !contentOnly && showButtons.unlock && item.locked"
                 class="tools--link" v-on:click.stop="unlockItem(item[actions.unlock.column.name], item[actions.unlock.column.identifier])"
                 :title="actions.unlock.label" :alt="actions.unlock.label"><i class="ion-android-lock"></i></a>

              <a v-if="!actions.read.disable && actions.read.action && !contentOnly && showButtons.read && actions.read.redirectUrl" class="tools--link"
                @click.prevent="navigateToDetail(item)" :title="actions.read.label" :alt="actions.read.label"><i class="ion-search"></i></a>
              <a v-if="!actions.read.disable && actions.read.action && !contentOnly && showButtons.read && !actions.read.redirectUrl" class="tools--link"
                 @click="actions.read.action({item, index})" :title="actions.read.label" :alt="actions.read.label"><i class="ion-search"></i></a>

              <a v-if="actions.readsettings && !actions.readsettings.disable && actions.readsettings.action && !contentOnly && showButtons.readsettings" class="tools--link"
                 @click="actions.readsettings.action({item, index})" :title="actions.readsettings.label" :alt="actions.readsettings.label"><i class="ion-clipboard"></i></a>

              <a v-if="!actions.update.disable && !contentOnly && showButtons.update &&
              exportSdcWorkflow && actions.exportWorkflow && item.Version === 2"
                 class="tools--link"
                 @click="sdcWorkflowExport(item)" :title="actions.exportWorkflow.label"
                 :alt="actions.exportWorkflow.label"><i class="ion-android-download"></i></a>

              <a v-if="!actions.update.disable && actions.update.action && !contentOnly && showButtons.update && actions.read.redirectUrl" class="tools--link"
                :href="actions.update.redirectUrl({item})" :title="actions.update.label" :alt="actions.update.label"><i class="ion-edit"></i></a>

              <a v-if="actions.preview && !actions.preview.disable && actions.preview.action && !contentOnly && showButtons.preview && actions.preview.redirectUrl" class="tools--link"
                :href="actions.preview.redirectUrl({item})" :title="actions.preview.label" :alt="actions.preview.label"><i class="ion-eye"></i></a>

              <a v-if="!actions.update.disable && actions.update.action && !contentOnly && showButtons.update && !actions.read.redirectUrl" class="tools--link"
                 @click="actions.update.action({item, index})" :title="actions.update.label" :alt="actions.update.label"><i class="ion-edit"></i></a>

              <a v-if="!actions.delete.disable && actions.delete.column.identifier && !contentOnly && showButtons.delete" class="tools--link"
                 v-on:click.stop="deleteItem(item, actions.delete.column)" :title="actions.delete.label" :alt="actions.delete.label"><i
                class="ion-trash-b"></i></a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div v-if="filterSection !== 'false' && !itemsError" class="row row--nomargin">
        <div class="form-row items-discovered column__50" v-if="totalText && !itemsError && !contentOnly"
             v-html="$t('generic.overview.pagination.showing', {current: paginationCurrentItems, total: itemsTotal})"></div>
        <div class="form-row column__50 text-right">
          <div v-if="pagination.items && !contentOnly" class="pagination">
            <el-pagination
              @current-change="handlePaginationChange"
              :page-size="pagination.items"
              layout="prev, pager, next"
              :total="itemsTotal"
              :current-page="itemsParams.page">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete dialog -->
    <el-dialog :title="$t('generic.overview.dialog.delete.title')" v-model="dialogDeleteVisible" size="tiny">
      <span v-if="dialogDeleteUnitList.length > 9">
        <span>{{ $t('generic.overview.dialog.delete.tillDescriptionName') }}
          <span class="strong">{{dialogDeleteName}} </span>
          <span v-html="$t('generic.overview.dialog.delete.tillDescriptionUnit', {noUnits: dialogDeleteUnitList.length, units: dialogDeleteUnitFormatted})"></span>
        </span>
      </span>
      <span v-else-if="dialogDeleteUnitList.length > 0 && dialogDeleteUnitList.length < 10">
        <span>{{ $t('generic.overview.dialog.delete.tillDescriptionName')}}
          <span class="strong">{{dialogDeleteName}} </span>
          <span>{{ $t('generic.overview.dialog.delete.tillDescriptionUnits', {noUnits: dialogDeleteUnitList.length})}}</span>
        </span>
      </span>
      <span v-else>
        {{ $t('generic.overview.dialog.delete.description')}} <span class="strong">{{dialogDeleteName}}</span>?
      </span>
      <br/>
      <span>
              {{ $t('generic.overview.dialog.delete.confirmation') }}
          </span>
      <span slot="footer" class="dialog-footer">
            <el-button v-on:click="dialogDeleteVisible = false, dialogDeleteIdentifier = '', dialogDeleteLoading = ''">{{ $t('generic.overview.buttons.cancel') }}</el-button>
            <el-button type="primary" v-on:click="confirmDeleteItem"
                       v-bind:loading="dialogDeleteLoading">{{ $t('generic.overview.buttons.confirm') }}</el-button>
          </span>
    </el-dialog>

    <!-- Unlock dialog -->
    <el-dialog :title="$t('generic.overview.dialog.unlock.title')" v-model="dialogUnlockVisible" size="tiny">
      <span v-html="$t('generic.overview.dialog.unlock.description', {name: dialogUnlockName})"></span>
      <br/>
      <span>
              {{ $t('generic.overview.dialog.unlock.confirmation') }}
          </span>
      <span slot="footer" class="dialog-footer">
            <el-button v-on:click="dialogUnlockVisible = false, dialogUnlockIdentifier = '', dialogUnlockLoading = ''">{{ $t('generic.overview.buttons.cancel') }}</el-button>
            <el-button type="primary" v-on:click="confirmUnlockItem"
                       v-bind:loading="dialogUnlockLoading">{{ $t('generic.overview.buttons.confirm') }}</el-button>
          </span>
    </el-dialog>

    <!-- Filter dialog -->
    <el-dialog :title="$t('generic.overview.dialog.filter.title')" v-model="dialogFilterVisible" size="tiny">
      <span class="side--label" v-if="filterHasToBeDisplayed()" style="color:#2d4d5a"> {{ actions.filter.label  }}</span>
      <br/>
      <div class="row__column--50 text-left">
        <el-form :model="form" ref="form">
          <el-form-item prop="filter" class="item-checkbox item-checkbox-inline">
            <el-checkbox-group v-model="form.dialog_filter" :loading-text="loadingText" :loading="loadingFilterData" @change="changeFilterSelection()"
                               class="item-checkbox">
              <tr v-for="item in resultFilterDataIncluding" :key="item">
                <td>
                  <el-checkbox :label="item">{{ getFilterLabel(item) }}</el-checkbox>
                </td>
              </tr>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button native-type="cancel" class="button button--cancel" :title="$t('generic.overview.buttons.cancel')"
                       v-on:click="dialogFilterVisible = false">{{ $t('generic.overview.buttons.cancel') }}</el-button>
            <el-button type="primary" v-on:click="filterOverview()"
                       v-bind:loading="dialogUnlockLoading">{{ $t('generic.overview.buttons.ok') }}</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
  import Vue from 'vue'
  import getSymbolFromCurrency from 'currency-symbol-map'
  import DownloadFile from 'downloadjs'

  const searchUrlParamName = 'search'
  const pageUrlParamName = 'page'
  const pageSizeUrlParamName = 'pagesize'
  const filterParamName = 'filter'

  export default {
    name: 'DqOverview',
    replace: true,
    props: {
      dataSource: {
        type: Object,
        required: true,
        default: function () {
          return {
            endpoint: null
          }
        }
      },
      contentOnly: {
        default () {
          return false
        }
      },
      disableSort: {
        default () {
          return false
        }
      },
      filterSection: {
        default () {
          return true
        }
      },
      search: {
        default () {
          return true
        }
      },
      exportSdcWorkflow: {
        default () {
          return false
        }
      },
      generateSdcWorkflowFilename: {
        default () {
          return false
        }
      },
      userPermissionNeeded: {
        default () {
          return false
        }
      },
      transactionOverview: {
        default () {
          return false
        }
      },
      clearboxCampaignOverview: {
        default () {
          return false
        }
      },
      totalText: {
        default () {
          return true
        }
      },
      pagination: {
        type: Object,
        default () {
          return {
            items: 25
          }
        }
      },
      rows: {
        type: Object,
        default: function () {
          return {
            zebra: true
          }
        }
      },
      direction: {
        default () {
          return 'ASC'
        }
      },
      field: {
        default () {
          return 'name'
        }
      },
      overrideError: {
        default () {
          return null
        }
      },
      overrideClass: {
        default () {
          return ''
        }
      },
      hideIfNoRecords: {
        default () {
          return false
        }
      },
      columns: {
        type: Array,
        required: true
      },
      actions: {
        type: Object,
        default: function () {
          return {
            create: {
              label: Vue.t('generic.overview.buttons.create'),
              action: {},
              disable: false
            },
            read: {
              label: Vue.t('generic.overview.buttons.read'),
              action: {},
              disable: false
            },
            readsettings: {
              // label: Vue.t('generic.overview.buttons.read'),
              label: 'Read extra',
              action: {},
              disable: false
            },
            update: {
              label: Vue.t('generic.overview.buttons.update'),
              action: {},
              disable: false
            },
            preview: {
              label: Vue.t('generic.overview.buttons.preview'),
              action: {},
              disable: false
            },
            delete: {
              label: Vue.t('generic.overview.buttons.delete'),
              column: '',
              action: {},
              disable: false
            },
            unlock: {
              label: Vue.t('generic.overview.buttons.unlock'),
              column: '',
              action: {},
              disable: false
            },
            filter: {
              label: Vue.t('generic.overview.buttons.filter'),
              name: ''
            }
          }
        }
      },
      itemActions: [] // new generation actions which is loosely coupled to backend implementation
    },
    data: function () {
      return {
        itemsData: '',
        itemsTotal: 0,
        allItems: '',
        filterValues: '',
        itemsCurrentlyLoading: false,
        itemsSearchValue: '',
        oldSearchValue: '',
        itemsParams: {},
        itemsError: false,
        itemsShowLoading: true,

        componentErrorMessage: '',

        dialogUnlockVisible: false,
        dialogUnlockName: '',
        dialogUnlockIdentifier: '',
        dialogUnlockLoading: false,
        unlockParams: {},

        dialogDeleteVisible: false,
        dialogDeleteName: '',
        dialogDeleteIdentifier: '',
        // Used for showing units when deleting the till
        dialogDeleteUnitList: [],
        // Formatted unit list string
        dialogDeleteUnitFormatted: '',
        dialogDeleteLoading: false,
        deleteParams: {},

        dialogFilterVisible: false,

        paginationCurrentItems: '',
        paginationPageSizeOptions: [5, 10, 15, 20, 25, 50, 100],
        paginationPageSize: 10,

        getFunction: 'overviewFunction',

        searching: false,
        timer: 0,

        permissions: [{
          actions: {
            create: 'C',
            read: 'R',
            readsettings: 'R',
            update: 'U',
            preview: 'U', // the same as update
            delete: 'D',
            unlock: 'U'
          }
        }],
        showButtons: {
          create: false,
          read: false,
          update: false,
          preview: false,
          delete: false,
          unlock: false,
          readsettings: false
        },

        content: {},
        loadingText: Vue.t('generic.forms.loading'),
        loadingFilterData: true,
        resultFilterDataExcluding: [],
        resultFilterDataIncluding: [],
        form: {
          filter: [],
          showFilter: '',
          dialog_filter: []
        }
      }
    },
    watch: {
      '$route.params.uuid': 'getItems'
    },
    created: function () {
      let pagesizeFromRoute = this.$route.query.pagesize
      let pageFromRoute = this.$route.query.page
      let searchValueFromRoute = this.$route.query.search
      let filterFromRoute = this.$route.query.filter

      if (searchValueFromRoute && searchValueFromRoute !== '') {
        this.searchValue = searchValueFromRoute
        this.itemsParams.searchValue = searchValueFromRoute
        this.itemsSearchValue = searchValueFromRoute
        this.searching = true
      }

      if (pagesizeFromRoute && pagesizeFromRoute !== '') {
        this.pagination.items = pagesizeFromRoute
      }

      if (filterFromRoute && filterFromRoute !== '') {
        let filterArray = filterFromRoute.split(',')
        this.itemsParams.filterValues = filterArray
        this.form.filter = filterArray
      }

      this.itemsParams = {
        pagesize: this.pagination.items,
        direction: this.direction,
        field: this.field
      }
      // Set pagesize
      this.paginationPageSize = this.pagination.items

      if (pageFromRoute && pageFromRoute !== '') {
        let pageInt = parseInt(pageFromRoute, 10)
        this.itemsParams.page = pageInt
        this.current = pageInt
        this.pageNumber = pageInt
      }

      // Set buttons permissions
      this.checkRoles()

      // Request the data
      this.getItems()
    },
    computed: {
      getCurrentSession () {
        return this.$store.getters['generalSession/getCurrentSession']
      },
      getRoles () {
        return this.getCurrentSession.roles
      }
    },
    methods: {
      navigateToDetail (item) {
        const route = this.actions.read.redirectUrl({ item })

        if (typeof route === 'string') {
          // Ensure it's using Vue Router navigation
          this.$router.push(route)
        } else if (typeof route === 'object') {
          // Support named routes with params
          this.$router.push(route)
        }
      },
      sdcWorkflowExport (workflowForExport) {
        // Exporting of workflow not allowed for v1
        if (workflowForExport.Version === 1) {
          return
        }
        this.dataSource.exportSdcWorkflowFunction(workflowForExport.UUID).then((response) => {
          const filename = this.actions.generateSdcWorkflowFilename.action(workflowForExport)
          DownloadFile(response.bodyText, filename, 'application/xml')
        })
      },
      sort (s) {
        if (this.disableSort) {
          return
        }
        if (s === this.itemsParams.field) {
          this.itemsParams.direction = this.getSortDirection() === 'asc' ? 'desc' : 'asc'
        }
        this.itemsParams.field = s
        this.field = this.itemsParams.field
        this.direction = this.itemsParams.direction
        this.getItemsData(false)
      },
      isSortField (c) {
        if (this.disableSort) {
          return false
        }
        return (c === this.itemsParams.field)
      },
      isFilterField (c) {
        return (this.actions.filter !== undefined && this.actions.filter.name !== '' && this.actions.filter.name === c)
      },
      isFilterEnabled () {
        return (this.form.filter !== undefined && this.form.filter.length > 0)
      },
      getSortDirection () {
        if (this.itemsParams.direction !== null && this.itemsParams.direction !== undefined && this.itemsParams.direction.toLowerCase() === 'desc') {
          return 'desc'
        } else {
          return 'asc'
        }
      },
      startFilterScreen () {
        this.form.dialog_filter = this.form.filter
        this.dialogFilterVisible = true
      },
      filterHasToBeDisplayed () {
        return (!this.itemsError && this.actions.filter !== undefined && this.actions.filter.name !== '')
      },
      filterOverview () {
        this.form.filter = this.form.dialog_filter
        this.dialogFilterVisible = false
        this.handlePaginationChange(1)
      },
      changeFilterSelection () {
        /**
        if (this.form.dialog_filter.length > 0) {
          if (this.form.dialog_filter[this.form.dialog_filter.length - 1] === 'ALL_VALUES') {
            if (this.form.dialog_filter.length > this.resultFilterDataExcluding.length) {
              // Deselect all
              this.form.dialog_filter = []
            } else {
              // select all
              this.form.dialog_filter = this.filterValues
            }
          }
        }
         **/
      },
      getFilterLabel (item) {
        var returnStr = ''
        var arrayStr = item.split(' ')
        for (var i = 0; i < arrayStr.length; i++) {
          arrayStr[i] = arrayStr[i].slice(0, 1).toUpperCase().concat(arrayStr[i].slice(1).toLowerCase())
        }
        returnStr = arrayStr.join(' ')
        return returnStr
      },
      getFilterData () {
        this.resultFilterDataIncluding = this.filterValues
        this.loadingFilterData = false
      },
      // On change pagination current page
      handlePaginationChange (value) {
        // Set current page parem
        this.itemsParams.page = value
        // Refetch the data
        this.getItemsData(false)
      },
      handlePaginationPageSize () {
        // Set the page size
        this.itemsParams.pagesize = this.paginationPageSize
        this.itemsParams.page = 1
        this.pagination.items = this.paginationPageSize
        this.getItemsData(false)
      },
      checkRoles () {
        var roles = this.getRoles
        if (Object.keys(roles).length === 0 && roles.constructor === Object && this.getCurrentSession.state === 'ready') {
          this.$dataApi().endpoints.user.getUserPermissions().then((response) => {
            if (response.status === 200) {
              this.$store.commit('generalSession/setRoles', response.body)
              this.checkPermission()
            }
          }, (response) => {
            this.redirectToError('could_not_load', response.body.message)
          })
        } else {
          this.checkPermission()
        }
      },
      checkPermission () {
        // Get the prefix
        var prefix = this.$route.meta.prefix

        // Loop over the actions
        var actions = this.permissions[0].actions

        var permissions = this.getRoles

        for (var prop in actions) {
          // Skip loop if the property is from prototype
          if (!actions.hasOwnProperty(prop)) continue

          // Loop over the permissions and check if we have a match. If not set the showButtons property to false
          for (var property in permissions) {
            // Skip loop if the property is from prototype
            if (!permissions.hasOwnProperty(property)) continue

            if (this.$route.name === 'management.unit.read' && !this.contentOnly) {
              if (this.userPermissionNeeded) {
                let perm = permissions[property].permission
                if (perm === 'USR_R') {
                  this.showButtons['read'] = true
                  this.showButtons['unlock'] = true
                } else if (perm === 'USR_C') {
                  this.showButtons['create'] = true
                } else if (perm === 'USR_D') {
                  this.showButtons['delete'] = true
                } else if (perm === 'USR_U') {
                  this.showButtons['update'] = true
                  this.showButtons['preview'] = true
                }
              } else if (this.transactionOverview) {
                let perm = permissions[property].permission
                if (perm === 'TRA_R') {
                  this.showButtons['read'] = true
                }
              } else if (this.clearboxCampaignOverview) {
                let perm = permissions[property].permission
                if (perm === 'SDC_R') {
                  this.showButtons['read'] = true
                }
              }
            } else if (permissions[property].permission === prefix + actions[prop]) {
              if (prop === 'readsettings') {
                var userSession = this.$store.getters['generalSession/getCurrentSession']
                var userRoles = userSession.data.user.userRoles

                var showReadConfigButton = false

                for (let role of userRoles) {
                  if (role.code === 'dealerview') {
                    showReadConfigButton = true
                    break
                  }
                }

                // supervisor is same as super admin
                const isAdmin = userRoles.some(role => role.code === 'supervisor')
                const isDealerView = userRoles.some(role => role.code === 'dealerview')
                // hide read action on tills overview if user is not admin or dealerview
                if ((!isAdmin && !isDealerView) && this.$route.name === 'management.till') {
                  this.showButtons['read'] = false
                }

                this.showButtons[prop] = showReadConfigButton
              } else {
                this.showButtons[prop] = true
              }
            }
          }
        }
      },
      getItems () {
        return this.getItemsData(true)
      },
      // Fetch the data from the endpoint
      getItemsData (refreshFilterData) {
        // Start loading
        this.itemsShowLoading = true

        this.paginationPageSize = this.pagination.items

        // Check for uuid
        if (this.$route.params.uuid !== 'undefined') {
          if (this.$route.name === 'management.unit.read') {
            this.itemsParams.uuid = this.$route.params.uuid
          } else if (!this.contentOnly) {
            if (this.itemsParams.organizationUuid !== this.$route.params.uuid) {
              this.itemsParams.page = 1
            }
            this.itemsParams.organizationUuid = this.$route.params.uuid
          } else if (this.$route.params.transactionLineOverview) {
            this.itemsParams.uuid = this.$route.params.transactionUuid
          } else {
            this.itemsParams.uuid = this.$route.params.uuid
          }
        } else {
          this.itemsParams.organizationUuid = ''
          this.itemsParams.uuid = ''
        }

        // Set function for retrieving
        if (this.searching) {
          this.itemsParams.searchValue = this.itemsSearchValue
          this.getFunction = 'searchFunction'
        } else {
          this.itemsParams.searchValue = ''
          this.getFunction = 'overviewFunction'
        }
        if (this.form.filter.length > 0) {
          this.itemsParams.filterField = this.actions.filter.name
          this.itemsParams.filterValues = this.form.filter[0]
          for (var i = 1; i < this.form.filter.length; i++) {
            this.itemsParams.filterValues = this.itemsParams.filterValues + ',' + this.form.filter[i]
          }
        } else {
          this.itemsParams.filterValues = []
        }

        if (this.dataSource.endpoint === 'till' && this.$route.name === 'management.unit.read') {
          this.itemsParams = { uuid: this.$route.params.uuid, params: this.itemsParams }
        }

        this.dataSource[this.getFunction](this.itemsParams).then((response) => {
          // Check for result in body or in items
          this.content = (typeof response.body.items === 'object') ? response.body.items : [response.body]
          if (typeof this.content !== 'object' || this.content.length <= 0) {
            // Set not found message
            this.itemsShowLoading = false
            this.itemsError = Vue.t('generic.overview.search.noresults')
            // if not on the first page, and there is no data after deleting. Go on page before
            if (this.pageNumber > 1) {
              const previousPage = this.pageNumber - 1
              this.handlePaginationChange(previousPage)
            }
            return false
          }

          // Remove errors
          this.itemsError = false

          // Translate last transactions on the Unit details page
          if (this.dataSource.endpoint === 'unit' && this.$route.name === 'management.unit.read') {
            this.content = this.content.map((item) => ({
              ...item,
              type: this.$t(item.type)
            }))
          }

          // Set the items
          this.itemsData = this.content

          this.allItems = response.body.allItems
          this.filterValues = response.body.filterValues
          // Set total
          this.itemsTotal = response.body.totalItems ? response.body.totalItems : this.content.length

          // Set current page
          this.pageNumber = response.body.pageNumber

          // Set the current displaying info
          if (this.pageNumber === 1) {
            this.paginationCurrentItems = '1 - ' + (this.itemsTotal < this.pagination.items ? this.itemsTotal : this.pagination.items)
          } else if (this.pageNumber === Math.ceil(this.itemsTotal / this.pagination.items)) {
            this.paginationCurrentItems = (this.itemsTotal - this.content.length) + ' - ' + this.itemsTotal
          } else {
            this.paginationCurrentItems = (this.pageNumber - 1) * this.pagination.items + ' - ' + this.pageNumber * this.pagination.items
          }
          if (refreshFilterData) {
            this.getFilterData()
          }
          // Hide loading and show content
          this.itemsShowLoading = false
        }, (response) => {
          // Error
          this.itemsShowLoading = false
          this.itemsError = Vue.t('generic.overview.search.noresults')
          return false
        })
      },
      // Checks if user contains specific role
      containsUserRole (role) {
        var userSession = this.$store.getters['generalSession/getCurrentSession']
        var userRoles = userSession.data.user.userRoles
        for (let r of userRoles) {
          if (r.code === role) {
            return true
          }
        }
        return false
      },
      // Show dialog on delete
      unlockItem (name, identifier) {
        // Check if the identifier has a value
        if (identifier === '') {
          this.$message.error({message: Vue.t('generic.errors.emptycolumnidentifier')})
          return false
        }

        // Set the submit loading to false
        this.dialogUnlockLoading = false

        // Set the name to display in the dialog
        this.dialogUnlockName = (name !== '') ? name : ''

        // Show dialog
        this.dialogUnlockVisible = true

        // Set the identifier value
        this.dialogUnlockIdentifier = identifier
      },
      // On confirm unlock
      confirmUnlockItem () {
        // Check if the identifier is set
        if (this.dialogUnlockIdentifier === '') {
          this.$message.error({message: Vue.t('generic.errors.emptycolumnidentifier')})
          return false
        }

        // Set identifer and identifier value
        this.unlockParams[this.actions.unlock.column.identifier] = this.dialogUnlockIdentifier

        // Data api delete item
        this.dataSource.unlockFunction(this.unlockParams).then((response) => {
          // Success
          this.$message.success({message: Vue.t('generic.overview.pagination.success.unlocked', {field: this.dialogUnlockName})})
          // Set current page
          this.handlePaginationChange(1)
          // Refetch the data
          this.getItemsData(false)
        }, (response) => {
          // Error
          var errorMessage = (response.status === 400) ? response.statusText : response.body.message
          this.submitLoading = false
          this.redirectToError('unknown_error', errorMessage)
        })

        // Show loading icon in confirm button
        this.dialogUnlockLoading = true

        // Hide dialog
        this.dialogUnlockVisible = false
      },
      // Show dialog on delete
      deleteItem (item, column) {
        const name = item[column['name']]
        let identifier

        if (!column.identifier) {
          throw new Error('Identifier required for column definition')
        }

        if (typeof column.identifier === 'object') {
          identifier = {}

          for (const key in column.identifier) {
            if (!column.identifier.hasOwnProperty(key)) continue

            const value = column.identifier[key]

            if (value.indexOf('.') === -1) {
              identifier[key] = item[value]
            } else {
              const parts = value.split('.')
              let itemValue = item

              for (let i = 0; i < parts.length; i++) {
                itemValue = itemValue[parts[i]]
              }

              identifier[key] = itemValue
            }
          }
        } else {
          identifier = {}
          identifier[column.identifier] = item[column.identifier]
        }

        // Check if the identifier has a value
        if (identifier === '') {
          this.$message.error({message: Vue.t('generic.errors.emptycolumnidentifier')})
          return false
        }

        // Set the submit loading to false
        this.dialogDeleteLoading = false

        // Set the name to display in the dialog
        this.dialogDeleteName = (typeof name !== 'undefined') ? name : 'this item'

        // Show dialog
        this.dialogDeleteVisible = true

        // Set the identifier value
        this.dialogDeleteIdentifier = identifier

        // In case of tills, units to be disconnected need to be shown in dialog
        if (column.units) {
          this.dialogDeleteUnitList = item[column['units']].map(u => u.name)
          this.dialogDeleteUnitFormatted = this.dialogDeleteUnitList.map(d => '<li>&nbsp; &nbsp; &bull; <strong>' + d + '</strong></li>').join('')
        }
      },
      // On confirm delete
      confirmDeleteItem () {
        // Check if the identifier is set
        if (!this.dialogDeleteIdentifier) {
          this.$message.error({message: Vue.t('generic.errors.emptycolumnidentifier')})
          return false
        }

        // Set identifer and identifier value
        this.deleteParams = this.dialogDeleteIdentifier

        // Data api delete item
        this.dataSource.deleteFunction(this.deleteParams).then(() => {
          // Success
          this.$message.success({message: Vue.t('generic.overview.pagination.success.deleted', {field: this.dialogDeleteName})})
          // Refetch the data

          // refetch simple-tree if organization is deleted to update side menu
          if (this.$route.path === '/organization/overview') {
            this.$store.commit('generalOrganization/setOrganizationSimpleTree')
          }
          this.getItems()
        }, (response) => {
          // Error
          var errorMessage = (response.status === 400) ? response.statusText : response.body.message
          this.submitLoading = false
          this.redirectToError('unknown_error', errorMessage)
        })

        // Show loading icon in confirm button
        this.dialogDeleteLoading = true

        // Hide dialog
        this.dialogDeleteVisible = false
      },
      isEmpty (searchTerm) {
        return searchTerm === 'undefined' || !searchTerm || searchTerm === null || searchTerm === ''
      },
      searchOnChange () {
        let oldSearch = this.oldSearchValue
        let newSearch = this.itemsSearchValue
        // Return if there is no change in the search term
        if ((this.isEmpty(oldSearch) && this.isEmpty(newSearch)) || (oldSearch === newSearch)) {
          return
        }
        this.getSearch()
      },
      // Get search items
      getSearch () {
        this.searching = !this.isEmpty(this.itemsSearchValue)
        if (this.searching) {
          // Set loading to true
          this.itemsShowLoading = true
          this.itemsParams.page = 1
        }
        // Debounced getting of items; start after 350ms
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          this.getItems()
        }.bind(this), 350)
        this.oldSearchValue = this.itemsSearchValue
      },
      addParam (url, name, value) {
        if (value && value !== '') {
          let firstparam = url.indexOf('?') === -1
          url += (firstparam ? '?' : '&') + name + '=' + value
        }
        return url
      },
      constructNewReadUrl (baseurl, item) {
        return baseurl + item.uuid
      },
      constructNewOverviewUrl () {
        let url = window.location.pathname
        const currentRoute = this.$route.path
        const queryParams = {
          search: this.itemsSearchValue,
          page: this.itemsParams.page,
          pagesize: this.paginationPageSize,
          filter: this.itemsParams.filterValues
        }
        this.$router.replace({ path: currentRoute, query: queryParams })

        url = this.addParam(url, searchUrlParamName, this.itemsSearchValue)
        url = this.addParam(url, pageUrlParamName, this.itemsParams.page)
        url = this.addParam(url, pageSizeUrlParamName, this.paginationPageSize)
        url = this.addParam(url, filterParamName, this.itemsParams.filterValues)
        return url
      },
      // Different filters in which the column data can be filtered
      filter (value, filter, item) {
        var formatValue
        // Check if filter is set
        if (typeof filter !== 'undefined') {
          if (value !== '') {
            switch (filter.type) {
              case 'object': // Get data from the object
                if (typeof value === 'object' && value !== null) {
                  switch (filter.select) {
                    case 'first':
                      formatValue = value[0][filter.name]
                      break
                    case 'last':
                      formatValue = value[Object.keys(value)[Object.keys(value).length - 1]][filter.name]
                      break
                    default:
                      formatValue = value[filter.name]
                      break
                  }
                }
                break
              case 'array': // Get data from the array
                var arr = []
                for (var i = 0; i < value.length; i++) {
                  arr.push(value[i][filter.key])
                }
                formatValue = arr.join(', ')
                break
              case 'uppercase': // String to uppercase
                formatValue = value.toUpperCase()
                break
              case 'lowercase': // String to lowercase
                formatValue = value.toLowerCase()
                break
              case 'currency': // Format number to currency format with decimals and thousands seperator
                {
                  formatValue = parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  formatValue = (formatValue === 'NaN') ? '' : formatValue
                  let currencySymbol = getSymbolFromCurrency(item.currency)
                  if (formatValue !== '') {
                    formatValue = (typeof currencySymbol !== 'undefined' ? currencySymbol : '') + ' ' + formatValue
                  } else {
                    formatValue = ''
                  }
                  break
                }
              case 'number': // Add decimals to the number
                {
                  let formatDecimal = (typeof filter.decimal === 'undefined') ? 2 : filter.decimal
                  formatValue = parseFloat(value).toFixed(formatDecimal)
                  formatValue = (formatValue === 'NaN') ? '' : formatValue
                  break
                }
              case 'numberplus': // Add decimals and thousands seperator
                {
                  let formatDecimal = (typeof filter.decimal === 'undefined') ? 2 : filter.decimal
                  formatValue = parseFloat(value).toFixed(formatDecimal).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  formatValue = (formatValue === 'NaN') ? '' : formatValue
                  break
                }
              case 'prefix': // Add a prefix before the string
                formatValue = filter.prefix + value.toUpperCase()
                break
            }
          }
        } else {
          formatValue = value
        }

        return formatValue
      }
    },
    // Redirect to the error page
    redirectToError (error, text) {
      this.$router.push({
        name: 'generic.error.ErrorPage',
        params: {
          error_response: {
            error_message: error,
            error_text: text
          }
        }
      })
    }
  }
</script>

<style scoped>
.strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// overview.vue?09bcdfea